import { apiClient } from './client';
import { API_BASE_URL } from '../config/adminConfig';

export async function fetchBanners() {
  const { data } = await apiClient.get('/banners');
  return data;
}

export async function createBanner({ title, imageFile }) {
  const formData = new FormData();
  formData.append('title', title);
  formData.append('image', imageFile);

  const { data } = await apiClient.post('/banners', formData);
  return data;
}

export async function updateBanner(id, { title, imageFile }) {
  const formData = new FormData();
  formData.append('title', title);
  if (imageFile) {
    formData.append('image', imageFile);
  }

  const { data } = await apiClient.post(`/banners/${id}`, formData);
  return data;
}

export async function deleteBanner(id) {
  const { data } = await apiClient.delete(`/banners/${id}`);
  return data;
}

export function extractBannerFromResponse(data) {
  return data?.data ?? data;
}

export function extractBannersFromResponse(data) {
  const payload = data?.data ?? data;
  if (Array.isArray(payload)) {
    return payload;
  }
  if (Array.isArray(payload?.data)) {
    return payload.data;
  }
  return [];
}

export function mapBannerToSlide(banner) {
  const title = banner?.title || 'inmotion';

  return {
    id: banner.id,
    image: getBannerImageUrl(banner),
    imageAlt: title,
  };
}

export function getBannerImageUrl(banner) {
  const image = banner?.image_url || banner?.image;
  if (!image) return '';

  if (/^https?:\/\//i.test(image)) {
    return image;
  }

  const origin = API_BASE_URL.replace(/\/api\/?$/, '');
  return image.startsWith('/') ? `${origin}${image}` : `${origin}/${image}`;
}
